import axios from 'axios';
import Handlers from './handlers'

const API_PATH = 'warranty_claim_payments/';

class warrantyClaimPaymentsService {
	listFiltered(requestData) {
        const url = API_PATH + 'list_filtered';
        return new Promise((resolve, reject) => {
            axios.post(url, requestData)
                .then(response => {
                    // handle success
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    // handle error
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
    import(formData) {
        const url = API_PATH + 'import';
        return new Promise((resolve, reject) => {
            axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                // handle success
                Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
            })
            .catch(error => {
                // handle error
                Handlers.ERROR_HANDLER(url, error, null, reject);
            });
        });
    }
}

export default new warrantyClaimPaymentsService();